import type { FaireProductEntity } from "../../entity_types/product";

export const p_qj3ck5t6pq: FaireProductEntity = {
  token: "p_qj3ck5t6pq",
  type: "product",
  name: "18K Gold Filled 4mm CZ Crystal Chain for jewelry making",
  brandToken: "b_h8r8747rcv",
  brandName: "Margarita Jewelry Supplies",
  imageUrl:
    "https://cdn.faire.com/fastly/828668ae96311877eb10a5a94fbd088825e7f30021b4e1eeecee50c6d11ec09e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1798b3158d13ef9a7e19700392dea1857bc82901702a8c73b7b12d2bae4ae154.jpeg",
    "https://cdn.faire.com/fastly/a59cdd4761b9184adca415d9cc410230ab674e92a1f39e18867849481f161261.jpeg",
  ],
  priceDollars: 9.6,
  description:
    "18K Gold Filled 4mm CZ Crystal Chain – Sparkling Luxury by the Foot\n\nElevate your jewelry collections with our 18K Gold Filled CZ Crystal Chain. Featuring perfectly spaced 4mm round-cut cubic zirconia beads, this dazzling chain is the ideal foundation for creating elegant necklaces, delicate bracelets, and sparkling custom pieces. It offers the brilliant radiant shine, durability, and hypoallergenic quality your customers expect. The premium CZ beads catch and reflect light beautifully, maximizing your creative possibilities and profitability.\n\nPRODUCT DETAILS:\n\n• Material: 18K Gold Filled over a high-quality brass core\n• Properties: Hypoallergenic, lead-free, and nickel-free—safe for sensitive skin\n• Style: Crystal Bead CZ Chain\n• Bead Size: 4mm round-cut cubic zirconia crystals\n• Order Options: Available by the foot in bulk increments\n\nPERFECT FOR:\n\n• Elegant necklaces, chokers, and drop earrings\n• Delicate sparkling bracelets and anklets\n• High-end bridal and evening jewelry collections\n• Professional wholesale jewelry production\n\nStock up on this sparkling CZ chain to add a touch of luxury to your jewelry designs, artisan creations, and boutique collections.",
  tags: [],
  msrpDollars: 12.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:59.666Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
